'use strict';

var PageManager = require('./page/PageManager');
var ViewManager = require('./view/ViewManager');

function NavDrawerService ($rootScope) {

  this.getPageIndex = function (pageId) {
    return this._pages[pageId];
  };

  this.getPageManager = function () {
    return PageManager.create('nav');
  };

  this.getViewManager = function (pageId) {
    return ViewManager.create(pageId);
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Event Handlers
  /////////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Trigger to reset the drawer state
   *
   * @param  {Object} e Event
   */
  var onResetState = function (e) {
    PageManager.destroyAll();
    ViewManager.destroyAll();
    e.stopPropagation();
  }.bind(this);

  $rootScope.$on('sbNavDrawer:resetState', onResetState);
}

module.exports = NavDrawerService;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/layout/src/nav/NavDrawerService.js